import {
  FormControl,
  IconButton,
  Button,
  Input,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { MdAddAPhoto } from "react-icons/md";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { token } from "../../API";
import FUStyles from "./FUStyles";

const FileUpload = ({ callback, clearBool, came }) => {
  const [file, setFile] = useState("");
  const [fileName, setFilename] = useState(null);
  const [load, setLoad] = useState(false);
  const [viewBool, setViewBool] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [name, setName] = useState("");

  const onChange = (e) => {
    setFile(e.target.files[0]);
    const objectUrl = URL.createObjectURL(e.target.files[0]);
    setName(e.target.files[0].name);
    setFilename(objectUrl);
    setViewBool(true);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", file, name);
    console.log(file);
    setImage(formData);
    setLoad(true);
  };
  useEffect(() => {
    if (clearBool) {
      setFile("");
      setFilename(null);
      setViewBool(false);
      setIsUploaded(false);
    }
  }, [clearBool]);

  const setImage = async (body) => {
    const url = `http://164.90.236.174:1988/koinot/attachment/uploadPhotoFileList/NEWS?requestMethod=POST`;
    const config = {
      headers: {
        "Content-type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const res = await axios.post(url, body, config);
      setFilename(res.data.object[0].link);
      callback(res);
      setLoad(false);
      setIsUploaded(true);
      return res;
    } catch (error) {
      setLoad(false);
      console.error(error);
      return { error: true, error };
    }
  };
  return (
    <FUStyles>
      <form onSubmit={onSubmit} className={viewBool ? "w-50" : "w-100"}>
        <div
          className={`${viewBool ? "d-block" : "d-none"} upload-model w-100`}
        >
          <div className={`w-100`}>
            <img
              src={fileName !== null ? fileName : ""}
              alt=""
              className="w-100"
            />
            <textarea
              className="form-control"
              id="image_name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              rows="1"
            ></textarea>
          </div>
        </div>
        <input
          accept="image/*"
          id="icon-button-file"
          type="file"
          style={{ display: "none" }}
          onChange={onChange}
        />
        <label htmlFor="icon-button-file" className="w-100">
          <Button
            fullWidth
            variant="contained"
            color="primary"
            component="span"
            startIcon={<MdAddAPhoto />}
          >
            {fileName !== null ? "Rasmni o'zgartrish" : "Rasmni yuklash"}
          </Button>
        </label>
        <br /> <br />
        <Button
          className={viewBool ? "" : "d-none"}
          fullWidth
          variant="contained"
          color="primary"
          component="span"
          onClick={onSubmit}
          startIcon={<AiOutlineCloudUpload />}
          type="submit"
        >
          Saqlash
        </Button>
        <br /> <br />
        <div
          className={`${
            isUploaded ? "d-block" : "d-none"
          } p-3 badge bg-success`}
        >
          <p> Rasm qo'yildi va postga biriktirildi !</p>
        </div>
        <div className={`${load ? "d-block" : "d-none"} loading`}>
          <div className="lds-ripple">
            <div></div>
            <div></div>
          </div>
        </div>
        <br />
      </form>

      {/* <div className="w-75 m-auto">
        <img src={fileName ? fileName : ""} alt="" className="img-fluid" />
      </div> */}
    </FUStyles>
  );
};

export default FileUpload;



// WEBPACK FOOTER //
// ./src/Components/FileUpload/index.js